import BlocText from './blocText';

export default BlocText;
